import LinearGradient from "./LinearGradient.js";
/**
 * All props pass through to `<LinearGradient {...props} />`
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function GradientTealBlue(_ref) {
  let {
    from = '#17EAD9',
    to = '#6078EA',
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(LinearGradient, {
    from: from,
    to: to,
    ...restProps
  });
}